import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    canceling: string;
    cancelingAriaLabel: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Status label when transfer is being canceled */
            canceling: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "CancelingJobStatus.canceling?c=3pts8ds62m9hz", defaultMessage: "Canceling\u2026" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Aria label for spinner when canceling */
            cancelingAriaLabel: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "CancelingJobStatus.cancelingAriaLabel?c=3a3fujui0d5ac", defaultMessage: "Canceling" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
